import React from 'react';
import { css } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import { CheckButton } from '../mui/checkButton';
import { color } from '../../styles';
import { CareRecordFormHook } from '@/hooks/useCareRecordForm';

interface Props {
  form: CareRecordFormHook;
}

const ContentContainer = css`
  width: 480px;
  margin-bottom: 16px;
`;

const AlignCenter = css`
  display: flex;
  align-items: center;
`;

const ContentTitle = css`
  margin-bottom: 2px;
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 0.3em;
  border-bottom: 3px solid ${color.dark_gray};
`;

const InheritedWidth = css`
  width: inherit;
`;

const InnerRowContainer = css`
  height: 72px;
`;

export const CareRecordUseDiaperSection = ({ form }: Props) => {
  const { t, i18n } = useTranslation();
  if (!i18n.language.startsWith('ja')) return null;

  return (
    <div css={[ContentContainer]}>
      <div css={[AlignCenter, ContentTitle]}>{t('use', '交換')}</div>
      <div css={InheritedWidth}>
        <div css={[AlignCenter, InnerRowContainer]} style={{ gap: '8px' }}>
          <CheckButton onClick={form.handleClickPantButton}>{t('diaperPants', 'テープ/パンツ')}</CheckButton>
          <CheckButton onClick={form.handleClickPadButton}>{t('pad', 'パッド')}</CheckButton>
        </div>
      </div>
    </div>
  );
};
